import type { IMessageElement } from '@chainlit/react-client';

/**
 * The whole table behind an answer whose on-screen table was cut to 200 rows.
 *
 * signals-copilot attaches it as `signals-all-<n>-rows.xlsx`. It is not shown
 * as a separate file card: the table's own Excel button downloads it instead,
 * so there is one Excel button, and it exports everything (owner, 2026-09-24).
 */
export const FULL_TABLE_FILE = /^signals-all-(\d+)-rows\.xlsx$/;

/** The chat shows at most this many rows of one table (DISPLAY_MAX_ROWS). */
export const DISPLAYED_ROWS_CAP = 200;

export function isFullTableFile(element: IMessageElement): boolean {
  return element.type === 'file' && FULL_TABLE_FILE.test(element.name || '');
}

export function findFullTableFile(
  elements: IMessageElement[] | undefined
): IMessageElement | undefined {
  return (elements || []).find((e) => isFullTableFile(e) && !!e.url);
}
